/* eslint-disable no-console,no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {NumberWrapper, ContentWrapper,StyledModal} from '../CompanyDashBoardV2/styles';
import {RecognitionCloseIcon, AddIconBranding, RecognitionDeleteIcon} from '../../utils/icons';
import {StyledInputV2} from '../CreateEvent/style';
import {SubmitButton, Title} from './style'

class UpdateOrganization extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSecondaryDomain:props?.domainNameSecondary?true:false,
      hideSecondaryDomain:false,
    }
  }

  hideShowSecondaryDomain = () => {
    this.setState({
      showSecondaryDomain: true,
      hideSecondaryDomain: false
    });
  };

  submitData = () => {
    const {updateOrganizationData}= this.props;
    updateOrganizationData()
  }

  handleDeleteSecondaryDomain = () => {
    this.setState({
      showSecondaryDomain: false,
      hideSecondaryDomain: true
    });
    this.props.onRemoveSecondaryDomain()
  };

  render() {
    const { show, onClose, domainName, onChangeInput, type, domainNameSecondary } = this.props;
    const { showSecondaryDomain } = this.state;
    return (
      <StyledModal show={show} width={"600px"} height="auto" onHide={() => onClose()} padding="16px">
        <NumberWrapper>
          <div className='stepHeading'>
            {type=="create"?"Add Domain":"Update Domain"}
            <div className='cross' onClick={() => onClose()}>
              {RecognitionCloseIcon('#F37A65')}
            </div>
          </div>
        </NumberWrapper>
        <div style={{width:"100%", height:"1px", background:"#EFEFEF", margin:"24px 0 20px 0"}}/>
        <Title>
          <div className='small-text'>Primary domain</div>
        </Title>
        <ContentWrapper border paddingValue="12px 0 20px 0">
          <StyledInputV2
            placeholder={("Write organization domain here...")}
            name={type=="create"?"organizationDomainName":"domainName"}
            onChange={onChangeInput}
            value={domainName}
            maxLength="100"
            isPadding={" 0px 20px 0px 12px"}
            border="1px solid #BDBDBD"
            pColor="#BDBDBD"
          />
        </ContentWrapper>
        {showSecondaryDomain && !this.state.hideSecondaryDomain && (
          <Title>
            <div className='small-text'>Secondary domain</div>
            {domainNameSecondary&&<div className='icon' onClick={this.handleDeleteSecondaryDomain}>
              {RecognitionDeleteIcon()}
            </div>}
          </Title>
        )}
        {showSecondaryDomain && !this.state.hideSecondaryDomain && (
          <ContentWrapper border paddingValue="12px 0 20px 0">
            <StyledInputV2
              placeholder={"Write organization domain here..."}
              name={type == "create" ? "organizationDomainNameSecondary" : "domainNameSecondary"}
              onChange={onChangeInput}
              value={domainNameSecondary}
              maxLength="100"
              isPadding={"0px 20px 0px 12px"}
              border="1px solid #BDBDBD"
              pColor="#BDBDBD"
            />
          </ContentWrapper>
        )}
        {<ContentWrapper border paddingValue="0">
          {!showSecondaryDomain?<div className='buttonwrap' >
            <div className='add' onClick={()=>this.hideShowSecondaryDomain()}>
              <AddIconBranding/>
              Add Secondary Domain
            </div>
            <div className='submit'>
              <SubmitButton 
                width="132px" 
                background={"#F37A65"} 
                color={"#FEFEFE"}
                margin="auto"
                disable={!domainName}
                onClick={!domainName?null:()=>this.submitData()}
              >Submit</SubmitButton>
            </div>
          </div>:
            <div className='wrap'>
              <SubmitButton 
                width="200px" 
                background={"#F37A65"} 
                color={"#FEFEFE"}
                margin="auto"
                disable={(!domainNameSecondary&&showSecondaryDomain||!domainName)}
                onClick={(!domainNameSecondary&&showSecondaryDomain||!domainName)?null:()=>this.submitData()}
              >
                Submit
              </SubmitButton>
            </div>}
        </ContentWrapper>}
      </StyledModal>
    );
  }
}

UpdateOrganization.propTypes = {
  show:PropTypes.bool,
  hidePopup: PropTypes.func,
  companyId: PropTypes.number,
  onClose: PropTypes.func,
  organizationDomain: PropTypes.string,
  domainName: PropTypes.string,
  onChangeInput: PropTypes.func,
  updateOrganizationData: PropTypes.func,
  type: PropTypes.string,
  domainNameSecondary: PropTypes.string,
  organizationDomainName: PropTypes.string,
  organizationDomainNameSecondary: PropTypes.string,
  onRemoveSecondaryDomain: PropTypes.func
};

export default UpdateOrganization;